import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Stack } from '@cp/ds/src/components/stack';
import { FieldLabel } from '@cp/ds/src/components/form/components/field/base/components/label';
import { CitySearchFormField } from '@cp/entities/location';
import { LocationIcon } from '@cp/ds/src/icons';
import { StartField } from './start';
import { EndField } from './end';
import { AvailableOnlyField } from './availableOnly';
import { DateField } from './date';
import { CatalogNavResumeViewProps } from './model';

const ViewDesktop: React.FC<CatalogNavResumeViewProps> = ({ careerId, form, submit, sx, careerDictionary }) => {
  const containerSx = React.useMemo(
    () =>
      mergeSx(
        {
          width: 1,
          backgroundColor: 'white',
          borderRadius: '16px',
          px: 2,
          py: 1.5,
          alignItems: 'flex-end',
          boxShadow: '14px 17px 40px 4px rgba(138, 182, 209, 0.08)',
        },
        sx,
      ),
    [sx],
  );

  return (
    <Stack component="form" direction="row" gap={3} noValidate sx={containerSx}>
      <CitySearchFormField
        endAdornment={<LocationIcon fontSize="1rem" sx={{ color: 'rgba(244, 105, 116, 1)' /* NOTE: hardcoded color used in design */ }} />}
        fieldContainerProps={{ sx: { flex: '1 1 0px' } }}
        fieldLabel="Город"
        placeholder="Поиск города..."
        size="small"
      />

      <DateField form={form} submit={submit} sx={{ alignItems: 'stretch' }} />

      <Stack direction="column">
        <FieldLabel>Время заказа</FieldLabel>
        <Stack direction="row" sx={{ flex: '1 1 0px', alignItems: 'flex-end' }}>
          <StartField form={form} submit={submit} sx={{ flex: '1 1 0px', alignItems: 'stretch' }} />
          <Box
            sx={{
              width: 12,
              borderTopWidth: 2,
              borderTopStyle: 'solid',
              borderTopColor: 'gray light',
              height: 20,
              mx: 0.5,
            }}
          />
          <EndField form={form} submit={submit} sx={{ flex: '1 1 0px', alignItems: 'stretch' }} />
        </Stack>
      </Stack>

      <Box sx={{ width: '1px', alignSelf: 'stretch', backgroundColor: 'gray middle' }} />

      <AvailableOnlyField
        careerDictionary={careerDictionary}
        careerId={careerId}
        form={form}
        reducedWidth
        sx={{ py: 1, alignSelf: 'center' }}
      />
    </Stack>
  );
};

export default ViewDesktop;
